import { Flex } from '@mantine/core'
import { MRT_ColumnDef } from 'mantine-react-table'
import React from 'react'
import { size } from 'src/variable/constant'
import CustomTooltip from 'src/components/CustomComponents/CustomTooltip'

import { useNavigate } from 'react-router-dom'
import EmployeePageList from 'src/containers/Employees/EmployeePageList'
import { RemoveCircle, CheckCircle } from '@mui/icons-material'

function EmployeesPage() {
	const navigate = useNavigate()
	const columns: MRT_ColumnDef[] = [
		// {
		// 	accessorKey: 'no',
		// 	header: 'No',
		// 	size: size.zero,
		// },
		// {
		// 	accessorKey: 'avatar',
		// 	header: 'Avatar',
		// 	size: size.zero,
		// 	Cell: ({ cell }) => {
		// 		return <Avatar src={cell.getValue<string>()} radius={50} />
		// 	},
		// },
		{
			accessorKey: 'name',
			header: 'Name',
			size: size.zero,
			maxSize: size.text,
			Cell: ({ cell }) => {
				return (
					<CustomTooltip label={cell.getValue<string>()} maxWidth={size.text} />
				)
			},
		},
		{
			accessorKey: 'email',
			header: 'Email',
			size: size.zero,
			maxSize: size.text,
			Cell: ({ cell }) => {
				return (
					<CustomTooltip label={cell.getValue<string>()} maxWidth={size.text} />
				)
			},
		},
		{
			accessorKey: 'phone',
			header: 'Phone',
			size: size.zero,
			maxSize: size.text,
		},
		{
			accessorKey: 'role',
			header: 'Role',
			size: size.zero,
		},
		{
			accessorKey: 'status',
			header: 'Status',
			size: size.zero,
			Cell: ({ cell }) => {
				const value = cell.getValue<string>();
				const Icon = !value ? RemoveCircle : CheckCircle
				const label = !value ? 'Blocked' : 'Available'
				return (
					<>
						<CustomTooltip label={label}>
							<Icon color={!value ? 'error' : 'success'} />
						</CustomTooltip>
					</>
				)
			}
		},
		// {
		// 	accessorKey: 'gender',
		// 	header: 'Gender',
		// 	size: size.zero,
		// },
		// {
		// 	accessorKey: 'status',
		// 	header: 'Status',
		// 	size: size.zero,
		// 	Cell: ({ cell }) => {
		// 		const val = cell.getValue<boolean>()
		// 		return <span>{val ? 'Active' : 'Inactive'}</span>
		// 	},
		// },
		// {
		// 	accessorKey: 'created_at',
		// 	header: 'Date join',
		// 	size: size.zero,
		// 	maxSize: size.text,
		// },
	]
	const fields = [
		{
			value: 'name',
			label: 'Name',
		},
		{
			value: 'email',
			label: 'Email',
		},
		{
			value: 'phone',
			label: 'Phone',
		},
		{
			value: 'role',
			label: 'Role',
		},
	]
	const handleDetail = (row) => {
		navigate(`/employees/${row?.original?.id}`)
	}
	return (
		<Flex sx={{ width: '100%' }}>
			<EmployeePageList
				columns={columns}
				fields={fields}
				handleDetail={handleDetail}
			/>
		</Flex>
	)
}

export default React.memo(EmployeesPage)
